import { Form, Input, Select } from "antd";
import { Controller } from "react-hook-form";
import styled from "styled-components";

const ErrorText = styled.div`
  color: red;
  font-size: 12px;
`;

export function FormTextFormField({
  control,
  name,
  defaultValue = "",
  placeholder,
  required,
  errors,
  label,
  type,
  hint,
  tooltip,
  extraLabel,
  className,
  ...rest
}) {
  console.log("errors", errors);
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={(props) => (
        <Form.Item
          label={label}
          tooltip={tooltip}
          rules={[{ required, message: errors?.message }]}
          className={`mb-3 mb-md-4 ${errors?.message && "error"} ${className}`}
        >
          <Input
            placeholder={placeholder || label}
            value={props.field.value}
            type={type}
            onChange={(e) => props.field.onChange(e.target.value)}
            {...rest}
          />
          {errors?.message && (
            <ErrorText className="red">{errors?.message}</ErrorText>
          )}
        </Form.Item>
      )}
    />
  );
}

export function FormDropdownField({
  control,
  name,
  defaultValue,
  width,
  placeholder,
  errors,
  shadow,
  bg,
  required,
  options,
  label,
  ...rest
}) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={(props) => (
        <Form.Item
          bg={bg}
          shadow={shadow}
          required={required}
          width={width}
          error={errors?.message ? true : undefined}
        >
          {label && <label className=" ">{label}</label>}
          <Select
            showSearch
            placeholder={placeholder}
            value={props.field.value}
            allowClear
            options={options}
            onChange={(_, item) => props.field.onChange(item?.value)}
            {...rest}
            // className="mt-2"
          />
          {errors?.message && <p className="error">{errors?.message}</p>}
        </Form.Item>
      )}
    />
  );
}
